export default __webpack_public_path__ + "static/media/card1-ecom.dfb07f9a.jpg";